import type { DatePickerTruncationUnit } from "metabase/querying/filters/types";

export const UNIT_GROUPS: DatePickerTruncationUnit[][] = [
  ["day", "week", "month"],
  ["quarter", "year"],
];
